import { render, staticRenderFns } from "./TableHandler.vue?vue&type=template&id=737f588d&"
import script from "./TableHandler.vue?vue&type=script&lang=js&"
export * from "./TableHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports